//@flow
import reducer from "./reducers";

import * as projectsOperations from "./operations";
import * as projectsSelectors from "./selectors";

export { projectsOperations, projectsSelectors };

export default reducer;
